<script setup lang="ts">
import IM from '@/components/im/Index.vue'
import MessageBox from '@/components/popup/dialog/MessageBox.vue';
</script>

<template>
    <div class="app-body">
        <main>
            <!-- IM -->
            <!-- <IM /> -->
            <RouterView v-slot="{ Component }">
                <Transition name="fade" mode="out-in">
                    <component :is="Component" />
                </Transition>
            </RouterView>

            <MessageBox />
        </main>
    </div>
</template>
<style scoped lang="scss"></style>
